import { Component } from '@angular/core';

@Component({
    selector: 'anniversary-background',
    templateUrl: './anniversary-background.component.pug',
    styleUrls: ['./anniversary-background.component.less'],
})
export class AnniversaryBackgroundComponent {
}
